













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TaftIcon extends Vue {
  @Prop(String)
    icon!: string;
  @Prop({ type: Boolean, default: false })
    small!: boolean;
  @Prop({ type: String, default: 'dark' })
    theme!: string; // light, dark
}
